import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Contacto } from '../interfaces/contactos.interface';
import 'rxjs/Rx';
import { map } from 'rxjs/operators';

@Injectable()
export class ContactosService {
  contactosUrl: string = 'https://website-47b95.firebaseio.com/contactos.json';
  contactoUrl: string = 'https://website-47b95.firebaseio.com/contactos/';
  constructor( private http: HttpClient) { }

  newMensaje(contacto: Contacto) {
    let body = JSON.stringify(contacto);
    let headers = new HttpHeaders ({
      'Content-Type': 'application/json'
    });
    return this.http.post<any>(this.contactosUrl, body, {headers})
    .pipe(map( (data: any) => {
      return data;
    }));
  }

  getMensaje(key$: string) {
    let url = `${ this.contactoUrl }/${ key$ }.json`;
    return this.http.get ( url )
    .pipe(map( (data: any) => {
      return data;
    }));
  }

  getListar() {
    return this.http.get ( this.contactosUrl )
    .pipe(map( (data: any) => {
      return data;
    }));
  }

}



// WEBPACK FOOTER //
// /Users/diego/Documents/SirisWebSite/WebSite/src/app/services/contactos.service.ts